import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../assets/css/Splash.css';
import logo from '../assets/images/Logo.svg';
import { Button } from 'react-bootstrap';
import { AiFillHome } from 'react-icons/ai';
function Four0Four() {
	const navigate = useNavigate();
	return (
		<div>
			<div className='home'>
				<Button className='button' onClick={() => navigate('/')}>
					<AiFillHome /> Home Page
				</Button>
			</div>
			<div className='splash-background'>
				<img src={logo} className='splash-logo' alt='logo' />
				<h1 className='display-1 fw-bold'>404</h1>
				<h2 className='font-weight-light'>Page Not Found</h2>
			</div>
		</div>
	);
}

export default Four0Four;
